import { createListenerMiddleware } from '@reduxjs/toolkit';
import { RootState, AppDispatch } from '..';
import { creatorActions } from '../slices/creatorSlice';

export const creatorMiddleware = createListenerMiddleware();

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.initialize,
	effect: async ({ payload }, listenerApi) => {},
});

creatorMiddleware.startListening.withTypes<RootState, AppDispatch>()({
	actionCreator: creatorActions.selectAttributeValue,
	effect: async ({ payload }, listenerApi) => {},
});
